package com.sweetlime.dungeonamigo.cache

import kotlin.String

public data class Spells(
  public val slug: String,
  public val name: String,
  public val level: String?,
  public val school: String?,
  public val casting_time: String?,
  public val range: String?,
  public val duration: String?,
  public val components: String?,
  public val material: String?,
  public val description: String?,
  public val higher_level: String?,
  public val classes: String?,
  public val ritual: String?,
)
